import { render, staticRenderFns } from "./RecentChangesModal.vue?vue&type=template&id=6cb021ea&"
import script from "./RecentChangesModal.vue?vue&type=script&lang=js&"
export * from "./RecentChangesModal.vue?vue&type=script&lang=js&"
import style0 from "./RecentChangesModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports